import(/* webpackMode: "eager" */ "/var/www/front/safiruni/front/app/[lang]/universities/page.tsx");
